import React, { useContext, useState, useEffect } from 'react'
import ValuePoint from 'admin/components/ValuePoint'
import UserGoals from 'admin/components/UserGoals'

import { Card, Grid, Typography, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

function Goals({
  collapseSections,
  toggleCollapse,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse in={collapseSections.goals} style={{ width: '100%' }}>
                <ValuePoint text="What would you like retirement to look like? Goals?" />
                <ValuePoint text="Where would your TSP come into play?" />
                <ValuePoint text="What makes you nervous about retirement?" />
                <ValuePoint text="Determine Pitch Type" />
                {intakeState?.riskTolerance === 'aggressive' ||
                intakeState?.riskTolerance === 'veryaggressive' ? (
                  <ValuePoint text="Wealth Management" />
                ) : (
                  <></>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="goals"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('goals')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Goals
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.goals
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.goals} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} xl={9} xl3={7}>
                <UserGoals
                  intakeState={intakeState}
                  updateIntakeStateAndSubmit={updateIntakeStateAndSubmit}
                  updateIntakeStateAtKey={updateIntakeStateAtKey}
                />
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Goals
